import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import CustomDropdown from "../../components/CustomDropdown";
import { saveUserProfile } from "../../utils/firebase";
import "../../styles/HomeGlobals.css";
import "../../styles/HomeStyle.css";
import "../../styles/HomeStyleGuide.css";
import "../../styles/Dropdown.css";

export default function Home() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    age: '',
    gender: '',
    usage: ''
  });

  // 年代のオプション
  const ageOptions = [
    { value: 'under10', label: t('under10') },
    { value: '10s', label: t('10s') },
    { value: '20s', label: t('20s') },
    { value: '30s', label: t('30s') },
    { value: '40s', label: t('40s') },
    { value: '50s', label: t('50s') },
    { value: '60s', label: t('60s') },
    { value: '70s', label: t('70s') },
    { value: '80s', label: t('80s') }
  ];

  // 性別のオプション
  const genderOptions = [
    { value: 'male', label: t('male') },
    { value: 'female', label: t('female') },
    { value: 'other', label: t('other') }
  ];

  // 利用形態のオプション
  const usageOptions = [
    { value: 'personal', label: t('personal') },
    { value: 'business', label: t('business') },
    { value: 'educational', label: t('education') }
  ];

  const handleAgeSelect = (option) => {
    setFormData(prev => ({ ...prev, age: option.value }));
  };

  const handleGenderSelect = (option) => {
    setFormData(prev => ({ ...prev, gender: option.value }));
  };

  const handleUsageSelect = (option) => {
    setFormData(prev => ({ ...prev, usage: option.value }));
  };

  const handleSubmit = async () => {
    // バリデーション
    if (!formData.age || !formData.gender || !formData.usage) {
      alert(t('Please fill out all fields.'));
      return;
    }

    setIsLoading(true);
    
    try {
      // ユーザープロファイルをFirestoreに保存
      const profileData = {
        age: formData.age,
        gender: formData.gender,
        usage: formData.usage,
        // 追加情報
        deviceType: navigator.userAgent.includes('Mobile') ? 'mobile' : 'desktop',
        userAgent: navigator.userAgent,
        language: navigator.language || 'ja',
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      };
      
      const userId = await saveUserProfile(profileData);
      console.log('User profile saved with ID:', userId);
      
      // 次の画面に遷移
      navigate('/okuno-shima/renttutorial');
      
    } catch (error) {
      console.error('Failed to save user profile:', error);
      alert(t('Failed to save data. Please try again.'));
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div className="select-language">
      <div className="overlap-group-wrapper">
        <div className="overlap-group">
          <div className="rectangle"></div>
          <div className="app-logo-area">
            <img className="limot" src="/images/logo_limot.png" alt="Limot logo" />
          </div>
          <p className="app-description-ja">
            {t('Please answer the following questions')} <br/>
            {t('before using the service.')}
          </p>
          
          <fieldset className="age-fieldset">
            <legend className="text-wrapper-2">{t('1.Age')}</legend>
            <CustomDropdown
              options={ageOptions}
              placeholder={t("Please select")}
              onSelect={handleAgeSelect}
              ariaLabel={t('Select your age')}
              className="age-dropdown"
              disabled={isLoading}
            />
          </fieldset>
          
          <fieldset className="gender-fieldset">
            <legend className="text-wrapper-3">{t('2.Gender')}</legend>
            <CustomDropdown
              options={genderOptions}
              placeholder={t('Please select')}
              onSelect={handleGenderSelect}
              ariaLabel={t('Select your gender')}
              className="gender-dropdown"
              disabled={isLoading}
            />
          </fieldset>
          
          <fieldset className="usage-fieldset">
            <legend className="text-wrapper-4">{t('3.Purpose')}</legend>
            <CustomDropdown
              options={usageOptions}
              placeholder={t('Please select')}
              onSelect={handleUsageSelect}
              ariaLabel={t('Select your purpose')}
              className="usage-dropdown"
              disabled={isLoading}
            />
          </fieldset>
          
          <button 
            type="button" 
            className="mode-button" 
            onClick={handleSubmit}
            disabled={isLoading}
            style={isLoading ? { opacity: 0.6, cursor: 'not-allowed' } : {}}
          >
            <span className="text-wrapper-6">
              {isLoading ? t('Saving...') : t('Next')}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}